import PropTypes from "prop-types";
import iconPath from "./iconsLib";

const defaultStyles = { display: "inline-block", verticalAlign: "middle" };

const Icon = ({ size, icon, className, style, viewBox }) => {
  const styles = { ...defaultStyles, ...style };
  return (
    <svg
      fill="currentColor"
      className={className}
      style={styles}
      viewBox={viewBox}
      width={`${size}px`}
      height={`${size}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path d={iconPath[icon]} />
    </svg>
  );
};

Icon.defaultProps = {
  size: 16,
  color: "#000000",
  viewBox: "0 0 24 24",
  style: {},
  className: "MuiSvgIcon-root",
};

Icon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  icon: PropTypes.string,
  viewBox: PropTypes.string,
  style: PropTypes.any,
  className: PropTypes.string,
};

export default Icon;
